<!-- 产品-设备详情 -->
<template>
  <div class="md-layout">
    <!-- 卡片 设备详情表格 -->
    <div class="md-layout-item md-size-100">

      <simple-wizard :start-index="startIndex" @update:startIndex="updateIndex" class="plat" wizardClass = "plat">
        <template slot="header"><div></div></template>
        <!-- EVENT -->
        <wizard-tab >
          <template slot="label"> {{$I18n("event_list")}} </template>
          <div>
            <!-- 卡片-主体-查询表单 -->
            <div class="md-layout card-form">
              <div class="md-layout-item md-size-30 md-xsmall-size-50">
                <md-field>
                  <label>{{$I18n("user_id")}}</label>
                  <md-input v-model="eventForm.user_id"/>
                </md-field>
              </div>
              <div class="md-layout-item md-size-30 md-xsmall-size-50">
                <md-field>
                  <label>{{$I18n("push_type")}}</label>
                  <md-select v-model="eventForm.push_type">
                    <md-option :value="0" >{{$I18n("all")}}</md-option>
                    <md-option :value="1" >{{$I18n("msg")}}</md-option>
                    <md-option :value="2" >{{$I18n("email")}}</md-option>
                    <md-option :value="3" >{{$I18n("sms")}}</md-option>
                    <md-option :value="4" >{{$I18n("simple_phone")}}</md-option>
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-size-30 md-xsmall-size-50">
                <md-field>
                  <label>{{"UID"}}</label>
                  <md-input v-model="eventForm.uid"/>
                </md-field>
              </div>
              <!-- 表单-按钮-重新查询 (只在小屏幕中显示) -->
              <div class="md-layout-item md-size-10 left-layout-item" :style="{'padding-right':0}">
                <md-button class= "left-icon md-info " @click="form_changeEventData">
                  <md-icon>search</md-icon>{{$I18n("search")}}
                </md-button>
              </div>
            </div>
            <md-table v-model="event_tableData">
              <md-table-row slot="md-table-row" slot-scope="{ item }" >
                <md-table-cell :md-label="'ID'">{{ item.id }}</md-table-cell>
                <md-table-cell :md-label="$I18n('user_id')">{{ item.user_id }}</md-table-cell>
                <md-table-cell :md-label="'DevID'">{{ item.dev_id }}</md-table-cell>
                <md-table-cell :md-label="$I18n('push_type')">{{ item.push_type_name }}</md-table-cell>
                <md-table-cell :md-label="$I18n('alarm_event')">{{ item.alarm_event }}</md-table-cell>
                <md-table-cell :md-label="$I18n('cloud_id')">{{ item.link_video_id }}</md-table-cell>
                <md-table-cell :md-label="$I18n('thum_id')">{{ item.link_img_id }}</md-table-cell>
                <md-table-cell :md-label="$I18n('event_time')">{{ timestampToString1000(item.gmt_alarm) }}</md-table-cell>
                <md-table-cell :md-label="$I18n('create_time')">{{ timestampToString1000(item.gmt_create) }}</md-table-cell>
              </md-table-row>
              <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data")}} </md-table-empty-state>
            </md-table>
            <table-page :total="totalEven" :pageSize="pageSize" v-model="currentPageEvent"/>
          </div>
        </wizard-tab>
        <!-- PUSH -->
        <wizard-tab >
          <template slot="label"> {{$I18n("push_list")}} </template>
          <div>
            <!-- 卡片-主体-查询表单 -->
            <div class="md-layout card-form">
              <div class="md-layout-item md-size-15 md-xsmall-size-50">
                <md-field>
                  <label>{{$I18n("user_id")}}</label>
                  <md-input v-model="pushForm.link_id"/>
                </md-field>
              </div>
              <div class="md-layout-item md-size-15 md-xsmall-size-50">
                <md-field>
                  <label>{{$I18n("push_type")}}</label>
                  <md-select v-model="pushForm.push_type">
                    <md-option :value="0" >{{$I18n("all")}}</md-option>
                    <md-option :value="1" >{{$I18n("msg")}}</md-option>
                    <md-option :value="2" >{{$I18n("email")}}</md-option>
                    <md-option :value="3" >{{$I18n("sms")}}</md-option>
                    <md-option :value="4" >{{$I18n("simple_phone")}}</md-option>
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-size-15 md-xsmall-size-50">
                <md-field>
                  <label>{{"UID"}}</label>
                  <md-input v-model="pushForm.uid"/>
                </md-field>
              </div>
              <div class="md-layout-item md-size-15 md-xsmall-size-50">
                <md-field>
                  <label>{{"Token"}}</label>
                  <md-input v-model="pushForm.token"/>
                </md-field>
              </div>
              <div class="md-layout-item md-size-15 md-xsmall-size-50">
                <md-field>
                  <label>{{$I18n("send_status")}}</label>
                  <md-select v-model="pushForm.send_state">
                    <md-option :value="0" >{{$I18n("all")}}</md-option>
                    <md-option :value="1" >{{$I18n("sending")}}</md-option>
                    <md-option :value="2" >{{$I18n("sending_comp")}}</md-option>
                  </md-select>
                </md-field>
              </div>
              <!-- 表单-按钮-重新查询 (只在小屏幕中显示) -->
              <div class="md-layout-item md-size-25 left-layout-item" :style="{'padding-right':0}">
                <md-button class= "left-icon md-info " @click="form_changePushData">
                  <md-icon>search</md-icon>{{$I18n("search")}}
                </md-button>
              </div>
            </div>
            <md-table v-model="push_tableData">
              <md-table-row slot="md-table-row" slot-scope="{ item }" >
                <md-table-cell :md-label="'ID'">{{ item.id }}</md-table-cell>
                <md-table-cell :md-label="$I18n('user_id')">{{ item.link_id.length > 20 ?(item.link_id.slice(0,20) + "...") :item.link_id }}</md-table-cell>
                <md-table-cell :md-label="'Token'">{{ item.token.length > 20 ?(item.token.slice(0,20) + "...") :item.token }}</md-table-cell>
                <md-table-cell :md-label="$I18n('push_type')">{{ item.push_type_name }}</md-table-cell>
                <md-table-cell :md-label="$I18n('platform_flag')">{{ item.platform_flag }}</md-table-cell>
                <md-table-cell :md-label="$I18n('send_status')">{{ item.send_state_name }}</md-table-cell>
                <md-table-cell :md-label="$I18n('send_result')">{{ item.send_result }}</md-table-cell>
                <md-table-cell :md-label="$I18n('send_res_text')">{{ item.send_result_desc }}</md-table-cell>
                <md-table-cell :md-label="$I18n('send_time')">{{ timestampToString(item.send_time) }}</md-table-cell>
                <md-table-cell :md-label="$I18n('create_time')">{{ timestampToString(item.create_time) }}</md-table-cell>
                <md-table-cell :md-label="$I18n('operate')" class="button-box">
                  <div @click="open_modal(item)" @click.stop style='color: #00bcd4;cursor: pointer;'>
                    {{$I18n("more_info")}}
                  </div>
                </md-table-cell>
              </md-table-row>
              <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data")}} </md-table-empty-state>
            </md-table>
            <table-page :total="totalPush" :pageSize="pageSize" v-model="currentPagePush"/>
          </div>
        </wizard-tab>
        <!-- 云事件 -->
        <wizard-tab>
          <template slot="label">{{$I18n("cloud_event_list")}}</template>
          <div style="margin-bottom: 10px;">
            <!-- user_id uid event_type data_type -->
            <div class="md-layout card-form" style="margin-left: -14px;margin-right: -6px;">
              <!-- Label -->
              <div class="table-search-form-flex label-type">
                <div class="table-search-form-label">
                  {{$I18n("user_id")}}
                </div>
              </div>
              <!-- 表单-选择栏-查询类型{1:订单ID, 2:支付订单号, 3:APP ID, 4:购买用户ID, 5:设备ID} -->
              <div class="table-search-form-flex">
                <div class="table-search-form-box">
                  <el-input v-model="event_searchForm.user_id"/>
                </div>
              </div>
              <!-- Label -->
              <div class="table-search-form-flex label-type">
                <div class="table-search-form-label">
                  {{"UID"}}
                </div>
              </div>
              <!-- 项目类型选择 -->
              <div class="table-search-form-flex">
                <div class="table-search-form-box">
                  <el-input v-model="event_searchForm.uid"/>
                </div>
              </div>
              <!-- Label -->
              <div class="table-search-form-flex label-type">
                <div class="table-search-form-label">
                  {{$I18n("event_type")}}
                </div>
              </div>
              <div class="table-search-form-flex">
                <div class="table-search-form-box">
                  <el-select v-model="event_searchForm.event_type">
                    <el-option value="0" :label="$I18n('all')" />
                    <el-option v-for="item in alarmEventList" :key="item.id" :value="item.id" :label="item.name"></el-option>
                  </el-select>
                </div>
              </div>
              <!-- Label -->
              <div class="table-search-form-flex label-type">
                <div class="table-search-form-label">
                  {{$I18n("time_range")}}
                </div>
              </div>
              <!-- 表单-日期范围选择-创建时间 -->
              <div class="table-search-form-flex">
                <div class="table-search-form-box" style="width: 230px;">
                  <el-date-picker :picker-options="pickerOptions" v-model="event_searchForm.create_time" class="md-date-form-item" align="left" type="daterange" range-separator="~" prefixIcon="no" value-format="yyyy-MM-dd HH:mm:ss" :start-placeholder="$I18n('start')" :end-placeholder="$I18n('end')"/>
                </div>
              </div>
              <!-- Label -->
              <div class="table-search-form-flex label-type">
                <div class="table-search-form-label">
                  {{$I18n("data_type")}}
                </div>
              </div>
              <div class="table-search-form-flex">
                <div class="table-search-form-box">
                  <el-select v-model="event_searchForm.data_type">
                    <el-option value="1" :label="$I18n('nm_data')" />
                    <el-option value="2" :label="$I18n('his_data')" />
                  </el-select>
                </div>
              </div>
            </div>
          </div>
          <div class="md-layout md-layout-item left-layout-item" :style="{'justify-content': 'flex-end'}">
            <md-button class="left-icon md-info" @click="form_event_search">
              <md-icon>search</md-icon>
              {{$I18n("search")}}
            </md-button>
            <md-button class="md-info" @click="form_event_reset" style="margin-right: 5px;">
              <md-icon>refresh</md-icon>
              {{$I18n("reset")}}
            </md-button>
          </div>
          <div>
            <!-- ID  用户ID  Uid  通道号  事件类型 缩略图ID 开始时间  结束时间 创建时间  操作 -->
            <md-table v-model="cloud_event_tableData">
              <md-table-row slot="md-table-row" slot-scope="{ item }" >
                <md-table-cell :md-label="'ID'">{{ item.id }}</md-table-cell>
                <md-table-cell :md-label="$I18n('user_id')">{{
                  !item.user_id 
                    ? ""
                    : item.user_id.length > 20 
                      ?(item.user_id.slice(0,20) + "...") 
                      :item.user_id 
                }}</md-table-cell>
                <md-table-cell :md-label="'Uid'">{{ item.uid }}</md-table-cell>
                <md-table-cell :md-label="$I18n('channel')">{{ item.channel }}</md-table-cell>
                <md-table-cell :md-label="$I18n('event_type')">{{ item.event_name }}</md-table-cell>
                <md-table-cell :md-label="$I18n('thum_id')">{{ item.thumb_id }}</md-table-cell>
                <md-table-cell :md-label="$I18n('start_time')">{{ item.start_time_01 }}</md-table-cell>
                <md-table-cell :md-label="$I18n('end_time')">{{ item.end_time_01 }}</md-table-cell>
                <md-table-cell :md-label="$I18n('create_time')">{{ item.create_time_01 }}</md-table-cell>
                <md-table-cell :md-label="$I18n('operate')" class="button-box" style="width: 120px;">
                  <div @click="open_cloud_modal(item)" @click.stop style='color: #00bcd4;cursor: pointer;'>
                    {{$I18n("more_info")}}
                  </div>
                </md-table-cell>
              </md-table-row>
              <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data")}} </md-table-empty-state>
            </md-table>
            <table-page-v2 :showTotal="true" :total="cloud_event_total" :pageSize="cloud_event_pageSize" @changePage="page => cloud_event_pageSize = page" v-model="cloud_event_currentPage"/>
          </div>

        </wizard-tab>
      </simple-wizard>
    </div>
    <!-- 弹窗-修改产品 -->
    <simple-modal ref="modal" :title="$I18n('details')" :right="true" :submitBtn="false" >
      <!-- 弹窗-主体 -->
      <template slot="body">
        <!-- 弹窗-表单 -->
        <div>
          <common-form-item 
            v-for="item in form_modalData" 
            v-model="modalData[item.keys]" 
            :key="item.keys" v-bind="item"
          />
        </div>
      </template>
    </simple-modal>
    <!-- 弹窗- -->
    <simple-modal ref="oss_modal" large :title="$I18n('details')" :right="true" :submitBtn="false" >
      <!-- 弹窗-主体 -->
      <template slot="body">
        <!-- 弹窗-表单 -->
        <div class="md-layout">
          <div class="md-layout-item md-size-100" v-if="cloud_event_detail.thumb_url" style="text-align: left !important;">
            <label class="md-form-label" style="color: rgb(170, 170, 170);font-weight: 400;"> {{$I18n("thum")}}: </label>
            <img @click="bigImage" :src="cloud_event_detail.thumb_url" style="max-height: 200px;cursor: pointer;"/>
          </div>
          <common-form-item 
            v-for="item in form_oss_modalData" 
            v-model="cloud_event_detail[item.keys]" 
            :key="item.keys" v-bind="item"
          />
          <div class="md-layout-item md-size-100">
            <!-- ID  名称(name) 文件类型（code_type）  文件路径（file_path） 开始时间  结束时间 创建时间 -->
            <md-table class="left-md-table" v-if="cloud_event_detail.files && cloud_event_detail.files.length" v-model="cloud_event_detail.files">
              <md-table-row slot="md-table-row" slot-scope="{ item }" >
                <md-table-cell :md-label="'ID'">{{ item.id }}</md-table-cell>
                <md-table-cell :md-label="$I18n('name')">{{ item.name }}</md-table-cell>
                <!-- <md-table-cell :md-label="$I18n('file_type')">{{ item.code_type }}</md-table-cell> -->
                <md-table-cell :md-label="$I18n('file_path')">{{ item.file_path }}</md-table-cell>
                <md-table-cell :md-label="$I18n('start_time')">{{ timestampToString1000(item.gmt_start) }}</md-table-cell>
                <md-table-cell :md-label="$I18n('end_time')">{{ timestampToString1000(new Date(item.gmt_end).getTime()) }}</md-table-cell>
                <md-table-cell :md-label="$I18n('create_time')">{{ timestampToString1000(new Date(item.gmt_create).getTime()) }}</md-table-cell>
              </md-table-row>
              <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data")}} </md-table-empty-state>
            </md-table>
          </div>
        </div>
      </template>
    </simple-modal>
    <black-shadow-modal ref="big_image" :image="cloud_event_detail.thumb_url" boxstyle="border:10px solid #444444;border-radius:10px;"/>
  </div>
</template>
<script>
import { timestampToString, timestampToString1000 } from "@/common/tools.js";
import { SimpleWizard, WizardTab } from "@/components";
import BlackShadowModal from '@/components/Common/BlackShadowModal.vue';

export default {
  components: {
    SimpleWizard,
    WizardTab,
    BlackShadowModal,
  },
  data() {
    return {
      pickerOptions: { // 时间范围选择
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      /* 云事件 */
        cloud_event_api: false,
        cloud_event_total : 0,
        cloud_event_pageSize : 10,
        cloud_event_currentPage : 1,
        alarmEventList: [],
        tableCloudEventInitData: [],
        cloud_event_detail:{},
        event_searchForm : { // 查询表单用的数据
          user_id     : "",
          uid         : "",
          event_type  : "0",
          data_type   : "1",
          create_time : ["",""],
        },
        event_searchData: {
          user_id   : "",
          uid       : "",
          event_type: 0,
          gmt_start : 0,
          gmt_end   : 0,
          data_type : 1,
        }, // 检索范围
      /* 云事件 */

      eventForm:{
        user_id : "",
        push_type : 0,
        uid : "",
      },
      eventSearch:{
        user_id : "",
        push_type : 0,
        uid : "",
      },

      pushForm:{
        link_id : "",
        uid : "",
        token : "",
        push_type : 0,
        send_state : 0,
      },
      pushSearch:{
        link_id : "",
        uid : "",
        token : "",
        push_type : 0,
        send_state : 0,
      },

      tableEventInitData : [], // 表格数据
      tablePushInitData : [], // 表格数据
      totalEven : 0,
      totalPush : 0,

      pageSize : 10,
      currentPageEvent : 1,
      currentPagePush : 1,

      modalData:{},
      startIndex : 0,
    };
  },
  mounted : function() {
    this.api_getEventPageData();
    this.api_getPushPageData();

    this.api_getCloudEventPage();
    this.api_getAlarmPageData();
  },
  watch: {
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    currentPageEvent(){
      this.api_getEventPageData();
    },
    currentPagePush(){
      this.api_getPushPageData();
    },
    cloud_event_pageSize(){
      this.cloud_event_currentPage = 1;
      this.api_getCloudEventPage();
    },
    cloud_event_currentPage(){
      this.api_getCloudEventPage();
    },
  },
  methods: {
    /* 云事件 */
      bigImage(){
        this.$refs.big_image.open();
      },
      api_getCloudEventPage(){
        this.$api.getOssCloudEvent({
          ...this.event_searchData,
          page_no: this.cloud_event_currentPage,
          page_size: this.cloud_event_pageSize,
        })
        .then(this.$Then(res => {
          this.tableCloudEventInitData = res.data;
          this.cloud_event_total = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.tableCloudEventInitData = [];
          this.cloud_event_total = 0;
        }))
      },
      api_getAlarmPageData(){
        console.log("1")
        this.$api.getMsgCfg({
          lang     : this.$router.history.current.query.lang == 'zh'?'zh-CN' :'en', 
          page_size: 9999,
          page_no  : 1,
        })
          .then(this.$Then(res => {
            this.alarmEventList = res.data;
          }))
          .catch(this.$Catch(this.$I18n("get_error"),() => {
            this.alarmEventList = [];
          }))
      },
      form_event_search(){
        this.event_searchData = {
          user_id     : this.event_searchForm.user_id,
          uid         : this.event_searchForm.uid,
          event_type  : parseInt(this.event_searchForm.event_type),
          data_type   : parseInt(this.event_searchForm.data_type),
          gmt_start   : this.event_searchForm.create_time && this.event_searchForm.create_time[0]? Math.ceil(new Date(this.event_searchForm.create_time[0]).getTime()/1000) :0,
          gmt_end     : this.event_searchForm.create_time && this.event_searchForm.create_time[1]? Math.ceil(new Date(this.event_searchForm.create_time[1]).getTime()/1000) + (3600* 24-1) :0,
        }
        this.cloud_event_currentPage = 1;
        this.api_getCloudEventPage();
      },
      form_event_reset(){
        this.event_searchForm = { // 查询表单用的数据
          user_id     : "",
          uid         : "",
          event_type  : "0",
          data_type   : "1",
          create_time : ["",""],
        }
      },
      open_cloud_modal(item){
        this.$api.getOssCloudEventDetail({
          id: item.id,
          data_type: this.event_searchData.data_type,
        })
          .then(res => {
            this.cloud_event_detail = {
              ...item,
              ...res.data,
            }
            this.$refs.oss_modal.open();
          })
          .catch(this.$Catch(this.$I18n("get_error")))
      },
      
    /* 云事件 */
    timestampToString1000: timestampToString1000,
    timestampToString: timestampToString,
    updateIndex(newIndex){
      this.startIndex = newIndex;
    },
    open_modal(item){
      this.modalData = item;
      this.$refs.modal.open();
    },
    api_getPushPageData(){ // API-获取页面信息
      // 获取角色
      this.$api.getAlarmPush({
          ...this.pushSearch,
          page_size: this.pageSize,
          page_no  : this.currentPagePush,
      })
        .then(this.$Then(res => {
          this.tablePushInitData = res.data;
          this.totalPush = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.tablePushInitData = [];
          this.totalPush = 0;
        }))
    },
    api_getEventPageData(){
      this.$api.getAlarmLog({
          ...this.eventSearch,
          page_size: this.pageSize,
          page_no  : this.currentPageEvent,
        })
        .then(this.$Then(res => {
          // console.log(res.data)
          this.tableEventInitData = res.data;
          this.totalEven = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.tableEventInitData = [];
          this.totalEven = 0;
        }))
    },
    form_changeEventData(){
      this.eventSearch = {...this.eventForm}
      this.currentPageEvent = 1;
      this.api_getEventPageData();
    },
    form_changePushData(){
      this.pushSearch = {...this.pushForm}
      this.currentPagePush = 1;
      this.api_getPushPageData();
    },
  },
  computed: {
    form_oss_modalData(){
      return [
        {
          label   : "ID",
          keys    : "id",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n('user_id'),
          keys    : "user_id",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-25",
        },{
          label   : "Uid",
          keys    : "uid",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n('channel'),
          keys    : "channel",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n('event_type'),
          keys    : "event_name",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n('thum_id'),
          keys    : "thumb_id",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n('lifecycle'),
          keys    : "lifecycle",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n('state'),
          keys    : "state",
          type    : "select",
          options : [
              {id:1 , name:this.$I18n("is_upload")},
              {id:2 , name:this.$I18n("uploaded")}
          ],
          disabled: true,
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n('start_time'),
          keys    : "start_time_01",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n('end_time'),
          keys    : "end_time_01",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n('create_time'),
          keys    : "create_time_01",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n('expi_time'),
          keys    : "expired_time_01",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-25",
        },{
          label   : this.$I18n('del_time'),
          keys    : "delete_time_01",
          type    : "input",
          disabled: true,
          class   : "md-layout-item md-size-25",
        },
      ]
    },
    cloud_event_tableData(){
      return this.tableCloudEventInitData.map(i => {
        const alarmInfo = this.alarmEventList.filter(a => a.type == i.event_type)[0];
        let event_name = "";
        if(alarmInfo){
          event_name = alarmInfo.name;
        }
        return {
          ...i,
          event_name: event_name,
          expired_time_01: this.timestampToString1000(i.gmt_expired),
          delete_time_01 : this.timestampToString1000(i.gmt_delete),
          create_time_01 : this.timestampToString1000(i.gmt_create),
          start_time_01  : this.timestampToString1000(i.gmt_start),
          end_time_01    : this.timestampToString1000(i.gmt_end),
        }
      })
    },
    event_tableData(){
      return this.tableEventInitData.map(i => {
        let push_type_name = this.$I18n("unknow");
        if(i.push_type === 1){
          push_type_name = this.$I18n("msg");
        } else if(i.push_type === 2){
          push_type_name = this.$I18n("email");
        } else if(i.push_type === 3){
          push_type_name = this.$I18n("sms");
        } else if(i.push_type === 4){
          push_type_name = this.$I18n("simple_phone");
        }
        return {
          ...i,
          push_type_name,
        }
      })
    },
    push_tableData(){
      return this.tablePushInitData.map(i => {
        let push_type_name = this.$I18n("unknow");
        if(i.push_type === 1){
          push_type_name = this.$I18n("msg");
        } else if(i.push_type === 2){
          push_type_name = this.$I18n("email");
        } else if(i.push_type === 3){
          push_type_name = this.$I18n("sms");
        } else if(i.push_type === 4){
          push_type_name = this.$I18n("simple_phone");
        }
        let send_state_name = this.$I18n("unknow");
        if(i.send_state === 1){
          send_state_name = this.$I18n("sending");
        } else if(i.send_state === 2){
          send_state_name = this.$I18n("sending_comp");
        }
        let sync_state_name = this.$I18n("unknow");
        if(i.sync_state === 1){
          sync_state_name = this.$I18n("wait_sync");
        } else if(i.sync_state === 2){
          sync_state_name = this.$I18n("succ_num");
        } else if(i.sync_state === 3){
          sync_state_name = this.$I18n("fail_num");
        }

        return {
          ...i,
          push_type_name,
          send_state_name,
          sync_state_name,
          send_time_date : this.timestampToString(i.send_time),
          sync_time_date : this.timestampToString(i.sync_time),
          created_thing_time_date : this.timestampToString1000(i.gmt_create),
        }
      })
    },
    form_modalData(){
      return [
        {
          label   : 'ID',
          keys    : "id",
          type    : "input",
          disabled: true,
        },
        {
          label   : this.$I18n('user_id'),
          keys    : "link_id",
          type    : "input",
          disabled: true,
        },
        {
          label   : 'Token',
          keys    : "token",
          type    : "input",
          disabled: true,
        },
        {
          label   : this.$I18n('push_type'),
          keys    : "push_type_name",
          type    : "input",
          disabled: true,
        },
        {
          label   : this.$I18n('platform_flag'),
          keys    : "platform_flag",
          type    : "input",
          disabled: true,
        },
        {
          label   : this.$I18n('push_content'),
          keys    : "push_msg",
          type    : "input",
          disabled: true,
        },
        {
          label   : this.$I18n('push_param'),
          keys    : "push_param",
          type    : "input",
          disabled: true,
        },
        {
          label   : this.$I18n('send_status'),
          keys    : "send_state_name",
          type    : "input",
          disabled: true,
        },
        {
          label   : this.$I18n('send_result'),
          keys    : "send_result",
          type    : "input",
          disabled: true,
        },
        {
          label   : this.$I18n('send_res_text'),
          keys    : "send_result_desc",
          type    : "input",
          disabled: true,
        },
        {
          label   : this.$I18n('sync_state'),
          keys    : "sync_state_name",
          type    : "input",
          disabled: true,
        },
        {
          label   : this.$I18n('send_time'),
          keys    : "send_time_date",
          type    : "input",
          disabled: true,
        },
        {
          label   : this.$I18n('sync_time'),
          keys    : "sync_time_date",
          type    : "input",
          disabled: true,
        },
        {
          label   : this.$I18n('created_thing_time'),
          keys    : "created_thing_time_date",
          type    : "input",
          disabled: true,
        },
      ]
    },
  },
}
</script>
<style lang="scss" scoped>
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 240px;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

</style>
<style scoped>
  .left-md-table /deep/ td.md-table-cell{
    text-align: left;
  }
</style>